import React from 'react';
import {Suggestions} from 'components';

export function Behaviors(props) {
  return (
    <Suggestions.List {...props}>
      <p>Spend more time with my family</p>
      <p>Be generous to others</p>
      <p>Spend quality time with myself every day</p>
      <p>Change my diet and eat healthy</p>
      <p>Exercise twice a week</p>
      <p>Stop adding more debt on my credit card</p>
      <p>Learn to say 'No'</p>
      <p>Take frequent vacations</p>
      <p>Stop talking and start listening</p>
      <p>Be true to my promises and commitments</p>
      <p>Express my love to my spouse/partner</p>
      <p>Express my appreciation to my employees</p>
      <p>Contribute 10% of my next paycheck to a good cause</p>
      <p>Make time to educate myself</p>
      <p>Decide to be happy</p>
      <p>Never give up</p>
      <p>Share my feelings with my spouse</p>
      <p>Smile to others</p>
      <p>Take action</p>
      <p>Clean up and re-design my home</p>
      <p>Save 20% of my income</p>
      <p>Attend religious service weekly</p>
    </Suggestions.List>
  );
}
